/**
 * Created by gocey on 28.08.17.
 */

 Box.Application.addModule('sv-video', function (context) {

    var _self = context;

    // retrieve a reference to jQuery
    var $ = context.getGlobal('jQuery'),
        Vimeo = context.getGlobal('Vimeo');

    return {

        init: function () {
            var iframe = context.element.querySelector('iframe');
            var playButton = context.element.querySelector('.playbutton');
            var autoPlayButton = context.element.querySelector('.playbutton-auto');
            var cookieConsent = context.element.querySelector('.cookieconsent-optout-statistics');
            var cookieText = context.element.querySelector('.cookieconsent-text');

            if (playButton && iframe) {
                playButton.addEventListener('click', function () {
                    if (Cookiebot && Cookiebot.consent && Cookiebot.consent.statistics && iframe.getAttribute('data-src').includes('vimeo')) {
                        // play video
                        if (!iframe.getAttribute('src')) {
                            iframe.setAttribute('src', iframe.getAttribute('data-src'));
                        }

                        $(playButton).addClass('is-hidden-animate');
                        $(playButton).parent('.is-overlay').removeClass('is-visible-video').addClass('is-hidden-video');
                        $(autoPlayButton).parent('.cookieconsent-optout-statistics').addClass('cookie-statistics-active');
                        var player = new Vimeo(iframe);
                        player.play();
                    } else {
                        if (Cookiebot && Cookiebot.consent) {
                            document.body.classList.remove('cookiebot-blocked')
                        } else {
                            document.body.classList.add('cookiebot-blocked')
                        }
                        $(cookieConsent).addClass('cookie-statistics-active')
                        $(cookieText).addClass('cookie-statistics-active')

                        $(autoPlayButton).parent('.cookieconsent-optout-statistics').addClass('is-hidden-video');
                        $(autoPlayButton).addClass('is-hidden-video');
                    }
                })
            }
        }

    }
}
)



// WEBPACK FOOTER //
// ./sv_cms/static/assets/js/modules/sv-video.js